'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import Image from 'next/image';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/modal/ConsultationModal/ConsultationModal.module.scss';
import CounselingCheckbox from '@/app/cc/_component/ui/modal/ConsultationModal/CounselingCheckbox';
import CounselingTextInput from '@/app/cc/_component/ui/modal/ConsultationModal/CounselingTextInput';
import CounselingTimeSelect from '@/app/cc/_component/ui/modal/ConsultationModal/CounselingTimeSelect';
import type { ConsultationFormData } from '@/app/cc/_types/consultationForm';
interface ConsultationFormProps {
  form: ConsultationFormData;
  onCounselingTimeChange: (value: ConsultationFormData['counselingTime']) => void;
  onNameChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  onContractFlagChange: (value: boolean) => void;
  onPrivacyUseFlagChange: (value: boolean) => void;
  onPrivacyProvideFlagChange: (value: boolean) => void;
  onOpenPrivacyUseSheet: () => void;
  onOpenPrivacyProvideSheet: () => void;
}
export default function ConsultationForm(t0) {
  const $ = _c(58);
  const {
    form,
    onCounselingTimeChange,
    onNameChange,
    onPhoneChange,
    onContractFlagChange,
    onPrivacyUseFlagChange,
    onPrivacyProvideFlagChange,
    onOpenPrivacyUseSheet,
    onOpenPrivacyProvideSheet
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text as="p" category="body" variant="r2" color="var(--color-gray-800)">상담이 가능한 시간을 남겨 주시면<br /> 빠르게 연락드릴게요</Text>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.info}>{t1}<div className={styles.infoItem}><div><Image src="/cc/image/icon_info.svg" alt="info" width={18} height={18} /></div><Text as="p" category="body" variant="r3" color="var(--color-gray-600)">상담은 평일만 가능해요</Text></div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <label htmlFor="counselingTime"><Text className={styles.inputLabel} as="p" category="caption" variant="sb1" color="var(--color-gray-700)">시간 선택</Text></label>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onCounselingTimeChange) {
    t4 = value => onCounselingTimeChange(value as ConsultationFormData['counselingTime']);
    $[3] = onCounselingTimeChange;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== form.counselingTime || $[6] !== t4) {
    t5 = <div className={styles.inputContainer}>{t3}<CounselingTimeSelect value={form.counselingTime} onChange={t4} /></div>;
    $[5] = form.counselingTime;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== form.name || $[9] !== onNameChange) {
    t6 = <CounselingTextInput id="name" label={"\uC774\uB984"} value={form.name} onChange={onNameChange} placeholder={"\uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694"} type="text" />;
    $[8] = form.name;
    $[9] = onNameChange;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== form.phone || $[12] !== onPhoneChange) {
    t7 = <CounselingTextInput id="phone" label={"\uC804\uD654\uBC88\uD638"} value={form.phone} onChange={onPhoneChange} placeholder={"-\uC5C6\uC774 \uC785\uB825\uD574\uC8FC\uC138\uC694"} type="tel" />;
    $[11] = form.phone;
    $[12] = onPhoneChange;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text className={styles.inputLabel} as="legend" category="caption" variant="sb1" color="var(--color-gray-700)">부동산 계약 여부</Text>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = form.contractFlag && styles.active;
  let t10;
  if ($[15] !== t9) {
    t10 = clsx(styles.contractButton, t9);
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== onContractFlagChange) {
    t11 = () => onContractFlagChange(true);
    $[17] = onContractFlagChange;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <button className={t10} type="button" onClick={t11}>부동산 계약 후</button>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = !form.contractFlag && styles.active;
  let t14;
  if ($[22] !== t13) {
    t14 = clsx(styles.contractButton, t13);
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== onContractFlagChange) {
    t15 = () => onContractFlagChange(false);
    $[24] = onContractFlagChange;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14 || $[27] !== t15) {
    t16 = <button className={t14} type="button" onClick={t15}>부동산 계약 전</button>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t12 || $[30] !== t16) {
    t17 = <div className={styles.contractButtonContainer}>{t12}{t16}</div>;
    $[29] = t12;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className={styles.infoItem} style={{
      alignItems: "flex-start"
    }}><div><Image src="/cc/image/icon_info.svg" alt="info" width={18} height={18} /></div><Text className={styles.infoText} as="p" category="body" variant="r3" color="var(--color-gray-600)">안심케어는 주거용 부동산 신규 계약 건에 한해 잔금일 전까지 신청 가능합니다.</Text></div>;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t17) {
    t19 = <fieldset className={styles.inputContainer}>{t8}{t17}{t18}</fieldset>;
    $[33] = t17;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Text as="p" category="button" variant="m3" color="var(--color-gray-600)" style={{
      fontSize: "1.6rem"
    }}>[필수] 개인정보 수집 및 이용 동의</Text>;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== onOpenPrivacyUseSheet) {
    t21 = <button type="button" className={styles.privacyProvideButton} onClick={onOpenPrivacyUseSheet}>{t20}</button>;
    $[36] = onOpenPrivacyUseSheet;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== form.privacyUseFlag || $[39] !== onPrivacyUseFlagChange || $[40] !== t21) {
    t22 = <CounselingCheckbox id="privacyUseFlag" name="privacyUseFlag" checked={form.privacyUseFlag} onChange={onPrivacyUseFlagChange}>{t21}</CounselingCheckbox>;
    $[38] = form.privacyUseFlag;
    $[39] = onPrivacyUseFlagChange;
    $[40] = t21;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Text as="p" category="button" variant="m3" color="var(--color-gray-600)" style={{
      fontSize: "1.6rem"
    }}>[필수] 개인정보 제3자 제공 동의</Text>;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== onOpenPrivacyProvideSheet) {
    t24 = <button type="button" className={styles.privacyProvideButton} onClick={onOpenPrivacyProvideSheet}>{t23}</button>;
    $[43] = onOpenPrivacyProvideSheet;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== form.privacyProvideFlag || $[46] !== onPrivacyProvideFlagChange || $[47] !== t24) {
    t25 = <CounselingCheckbox id="privacyProvideFlag" name="privacyProvideFlag" checked={form.privacyProvideFlag} onChange={onPrivacyProvideFlagChange}>{t24}</CounselingCheckbox>;
    $[45] = form.privacyProvideFlag;
    $[46] = onPrivacyProvideFlagChange;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t22 || $[50] !== t25) {
    t26 = <div className={styles.confirmContent}>{t22}{t25}</div>;
    $[49] = t22;
    $[50] = t25;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== t19 || $[53] !== t26 || $[54] !== t5 || $[55] !== t6 || $[56] !== t7) {
    t27 = <div className={styles.formContent}>{t2}<div className={styles.inputContent}>{t5}{t6}{t7}{t19}{t26}</div></div>;
    $[52] = t19;
    $[53] = t26;
    $[54] = t5;
    $[55] = t6;
    $[56] = t7;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  return t27;
}